$(document).ready(function() {
    function isMobile() {
        return window.innerWidth <= 991;
    }

    function toggleDropdowns() {
        if (isMobile()) {
            $('.navbar-nav .dropdown-toggle').off('click').on('click', function(e) {
                const $el = $(this).next('.dropdown-menu');

                $(this).toggleClass('active');
                $el.toggleClass('show');

                e.stopPropagation();
            });
        } else {
            // Remove custom handlers for larger screens
            $('.navbar-nav .dropdown-toggle').off('click').removeClass('active');
            $('.navbar-nav .dropdown-menu').off('click').removeClass('show');
        }
    }

    // Run on initial load
    toggleDropdowns();

    // Run on window resize
    $(window).resize(toggleDropdowns);
});
